import variants from './variants';
import styleOverrides from './styleOverrides';
import defaultProps from './defaultProps';

const components = {
  MuiAvatar: {
    styleOverrides: styleOverrides['avatar'],
  },
  MuiAlert: {
    defaultProps: defaultProps['alert'],
    styleOverrides: styleOverrides['alert'],
  },
  MuiPaper: {
    defaultProps: defaultProps['paper'],
  },
  MuiAppBar: {
    styleOverrides: styleOverrides['appBar'],
    defaultProps: defaultProps['appBar'],
  },
  MuiAutocomplete: {
    styleOverrides: styleOverrides['autocomplete'],
  },
  MuiButton: {
    styleOverrides: styleOverrides['button'],
    defaultProps: defaultProps['button'],
    variants: variants['button'],
  },
  MuiOutlinedInput: {
    styleOverrides: styleOverrides['outlinedInput'],
  },
  MuiTableRow: {
    variants: variants['tableRow'],
  },
  MuiTableCell: {
    styleOverrides: styleOverrides['tableCell'],
  },
  MuiTableHead: {
    styleOverrides: styleOverrides['tableHead'],
  },
  MuiTableSortLabel: {
    styleOverrides: styleOverrides['tableSortLabel'],
  },
  MuiTabs: {
    defaultProps: {
      textColor: 'inherit', // @TODO: Causes graphical glitch during ripple animation.
    },
    variants: variants['tabs'],
    styleOverrides: styleOverrides['tabs'],
  },
  MuiTab: {
    variants: variants['tab'],
    styleOverrides: styleOverrides['tab'],
  },
  MuiChip: {
    styleOverrides: styleOverrides['chip'],
    variants: variants['chip'],
  },
  MuiLinearProgress: {
    styleOverrides: styleOverrides['linearProgress'],
    defaultProps: defaultProps['linearProgress'],
  },
  MuiInputAdornment: {
    styleOverrides: styleOverrides['inputAdornment'],
  },
  MuiInputBase: {
    styleOverrides: styleOverrides['inputBase'],
  },
  MuiInputLabel: {
    styleOverrides: styleOverrides['inputLabel'],
  },
  MuiFormControlLabel: {
    variants: variants['formControlLabel'],
    styleOverrides: styleOverrides['formControlLabel'],
  },
  MuiFormGroup: {
    styleOverrides: styleOverrides['formGroup'],
  },
  MuiCheckbox: {
    styleOverrides: styleOverrides['checkbox'],
  },
  MuiRadio: {
    styleOverrides: styleOverrides['radio'],
    variants: variants['radio'],
  },
  MuiSelect: {
    styleOverrides: styleOverrides['select'],
  },
  MuiStep: {
    styleOverrides: styleOverrides['step'],
    variants: variants['step'],
  },
  MuiStepConnector: {
    styleOverrides: styleOverrides['stepConnector'],
  },
  MuiStepIcon: {
    styleOverrides: styleOverrides['stepIcon'],
  },
  MuiStepLabel: {
    styleOverrides: styleOverrides['stepLabel'],
  },
  MuiStepper: {
    styleOverrides: styleOverrides['stepper'],
  },
  MuiSwitch: {
    variants: variants['switch_'],
    styleOverrides: styleOverrides['switch'],
  },
  MuiIconButton: {
    variants: variants['iconButton'],
    defaultProps: defaultProps['iconButton'],
    styleOverrides: styleOverrides['iconButton'],
  },
  O2Pane: {
    variants: variants['pane'],
  },
  MuiDialog: {
    styleOverrides: styleOverrides['dialog'],
  },
  MuiDialogTitle: {
    styleOverrides: styleOverrides['dialogTitle'],
  },
  MuiDialogContent: {
    styleOverrides: styleOverrides['dialogContent'],
  },
  MuiDialogActions: {
    variants: variants['dialogActions'],
  },
  MuiLink: {
    styleOverrides: styleOverrides['link'],
    variants: variants['link'],
  },
  MuiList: {
    styleOverrides: styleOverrides['list'],
  },
  MuiListItem: {
    variants: variants['listItem'],
  },
  MuiListItemIcon: {
    variants: variants['listItemIcon'],
  },
  MuiListItemText: {
    variants: variants['listItemText'],
  },
  MuiTreeItem: {
    styleOverrides: styleOverrides['treeItem'],
  },
  MuiContainer: {
    variants: variants['container'],
  },
  MuiTextField: {
    styleOverrides: styleOverrides['textField'],
  },
  MuiToggleButton: {
    variants: variants['toggleButton'],
  },
  MuiBackdrop: {
    styleOverrides: styleOverrides['backdrop'],
  },
  MuiTypography: {
    variants: variants['typography'],
  },
  MuiToggleButtonGroup: {
    styleOverrides: styleOverrides['toggleButtonGroup'],
  },
  MuiBreadcrumbs: {
    styleOverrides: styleOverrides['breadcrumbs'],
  },
};

export default components;
